import { Routes } from '@angular/router';
import { LayoutComponent } from 'Admin/layout/layout.component'
import { OAuth2Service } from "@ngxsuit"

export const CHILDROUTES: Routes = [
    {
        path: 'stores/:store_id/urlrewritemgr', component: LayoutComponent,
        children: [
            {
                "path": "",
                "loadChildren": "UrlRewriter/page/urlrewritemgr.module#UrlRewriteMgrModule",
                canActivate:[OAuth2Service]
            },
        ]
    }
];

export const MENUS = [];

